@if (slides && slides.length > 0) {
<div
  class="event-slider relative overflow-hidden aspect-[1170/325] mb-6 rounded-lg"
  [ngClass]="slides[currentIndex].url ? 'cursor-pointer':''"
  role="link"
  tabindex="0"
  (click)="openSlide(slides[currentIndex])"
  (keyup.enter)="openSlide(slides[currentIndex])"
>
  @for (slide of slides; track $index; let i = $index) {
  <div
    class="event-slide absolute inset-0"
    [class.is-active]="currentIndex === i"
  >
    <img
      class="event-slide-image hidden md:block"
      [src]="slide.img"
      alt=""
    />
    <img
      class="event-slide-image block md:hidden"
      [src]="slide.mobileImg || slide.img"
      alt=""
    />
  </div>
  }

  <!-- <div class="event-overlay absolute inset-0"></div> -->

  <!-- Content -->
  <!-- <div
    class="absolute inset-0 flex flex-col justify-end p-6 text-white space-y-2 z-10"
  >
    <h1 class="text-xl font-semibold">
      {{ slides[currentIndex].title | translate }}
    </h1>
    <span class="text-sm font-medium">
      {{ slides[currentIndex].date | translate }}
    </span>
    <span class="text-sm max-w-xl">
      {{ slides[currentIndex].desc | translate }}
    </span>
  </div> -->

  <!-- Prev / Next arrows -->
  <!-- <button
    (click)="prev()"
    class="absolute left-2 top-1/2 -translate-y-1/2 bg-black/50 text-white p-2 rounded-full hover:bg-black/70 z-20"
  >
    ‹
  </button>
  <button
    (click)="next()"
    class="absolute right-2 top-1/2 -translate-y-1/2 bg-black/50 text-white p-2 rounded-full hover:bg-black/70 z-20"
  >
    ›
  </button> -->

  <!-- Dots -->
  <div class="absolute bottom-3 w-full flex justify-center gap-2 z-20">
    @for (slide of slides; track $index; let i = $index) { @if (slides.length >
    1) {
    <button
      (click)="$event.stopPropagation(); goToSlide(i)"
      class="w-3 h-3 rounded-full"
      [class.bg-white]="currentIndex === i"
      [class.bg-gray-400]="currentIndex !== i"
    ></button>
    } }
  </div>
</div>
}
